export var Runtime;
(function (Runtime) {
    let Client;
    (function (Client) {
        /**
         * Where client services run. Drives `createClientServices` routing.
         *
         * Defined in:
         *   {@link file://./../../dxos/config.proto}
         */
        let ServicesMode;
        (function (ServicesMode) {
            ServicesMode[ServicesMode["UNSPECIFIED_SERVICES_MODE"] = 0] = "UNSPECIFIED_SERVICES_MODE";
            ServicesMode[ServicesMode["HOST"] = 1] = "HOST";
            ServicesMode[ServicesMode["SHARED_WORKER"] = 2] = "SHARED_WORKER";
            ServicesMode[ServicesMode["DEDICATED_WORKER"] = 3] = "DEDICATED_WORKER";
        })(ServicesMode = Client.ServicesMode || (Client.ServicesMode = {}));
        let Storage;
        (function (Storage) {
            /**
             * Defined in:
             *   {@link file://./../../dxos/config.proto}
             */
            let StorageDriver;
            (function (StorageDriver) {
                StorageDriver[StorageDriver["RAM"] = 0] = "RAM";
                StorageDriver[StorageDriver["IDB"] = 1] = "IDB";
                StorageDriver[StorageDriver["CHROME"] = 2] = "CHROME";
                StorageDriver[StorageDriver["FIREFOX"] = 3] = "FIREFOX";
                StorageDriver[StorageDriver["NODE"] = 4] = "NODE";
                StorageDriver[StorageDriver["WEBFS"] = 5] = "WEBFS";
                StorageDriver[StorageDriver["LEVELJS"] = 11] = "LEVELJS";
                StorageDriver[StorageDriver["JSONDOWN"] = 12] = "JSONDOWN";
            })(StorageDriver = Storage.StorageDriver || (Storage.StorageDriver = {}));
            /**
             * presence of options.
             *
             * Defined in:
             *   {@link file://./../../dxos/config.proto}
             */
            let SqliteMode;
            (function (SqliteMode) {
                SqliteMode[SqliteMode["UNSPECIFIED_SQLITE_MODE"] = 0] = "UNSPECIFIED_SQLITE_MODE";
                SqliteMode[SqliteMode["MEMORY"] = 1] = "MEMORY";
                SqliteMode[SqliteMode["OPFS"] = 2] = "OPFS";
                SqliteMode[SqliteMode["FILE"] = 3] = "FILE";
            })(SqliteMode = Storage.SqliteMode || (Storage.SqliteMode = {}));
        })(Storage = Client.Storage || (Client.Storage = {}));
    })(Client = Runtime.Client || (Runtime.Client = {}));
})(Runtime || (Runtime = {}));
//# sourceMappingURL=config.js.map